<rw-modal
  modalId="copyActivationLinkModal"
  datapendoid="copy-activation-link-modal"
  datatestid="copy-activation-link-modal"
  [title]="'Copy Account Activation Link'"
  arialabel="Copy Account Activation Link"
  [dismissible]="true"
  size="lg"
  #modalRef
>
  <div modal-body>
    <div class="text_14">
      Copy and share account activation link for:
      {{ fullName }}
    </div>
    <div class="md-medium-tall p-t-sm display-flex">
      <input
        #copyLinkInput
        class="input_field"
        [disabled]="state === 'loading'"
        id="copyLinkField"
        aria-label="Activation link"
        value="{{ activationLink }}"
        placeholder="Activation link"
        title="Activation link to copy"
      />
      @if (state !== 'copied') {
        <app-button
          id="btnCopy"
          label="Copy"
          [disabled]="state === 'loading'"
          buttonStyle="primary"
          (clickActionEmitter)="copy()"
        >
        </app-button>
      }
      @else {
        <app-button
          id="btnCopied"
          label="Copied"
          showIcon="true"
          iconClass="fa-solid fa-check"
          disabled="true"
          buttonStyle="completed"
        >
        </app-button>
      }
    </div>
  </div>
</rw-modal>
